import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { api } from './services/api';
import messageReducer from './slices/message';
import translationsReducer from './slices/translations';
import searchReducer from './slices/search';
import type { RootState } from './types';
import errorHandler from './middleware/errorHandlerMiddleware';
import listenerMiddleware from './middleware/listenerMiddleware';
// Enhancements must be imported here to take effect.
import './services/enhancements/header';

const reducers = combineReducers({
  translations: translationsReducer,
  messages: messageReducer,
  search: searchReducer,
  [api.reducerPath]: api.reducer,
});

const middlewares = [api.middleware, errorHandler];

export const setupStore = (initialState?: Partial<RootState>) =>
  configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .prepend(listenerMiddleware.middleware)
        .concat(...middlewares),
    preloadedState: initialState,
  });

export const store = setupStore();

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;
